import React, { useEffect, useState } from "react";
import BottomSheetLayout from "../../../../../../../components/BottomSheetLayout";
import { Box, Typography, useTheme } from "@mui/material";
import CustomButton from "../../../../../../../components/CustomButton";
import StarFillSVG from "../../../../../../../../media/images/icons/star-fill";
import { grey } from "@mui/material/colors";
import QuestionCard from "../QuestionCard";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../../../services/fetcher";
import { useAppDispatch } from "../../../../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../../../redux/features/snackbarSlice";

export interface ISurveyQuestion {
  id: "65e455647a2e82084c618043";
  insertDate: "2024-03-03T10:48:04.59Z";
  role: 12;
  qstn: "میزان رضایت خود را از پاسخگویی شرکت حمل و نقل اعلام نمایید . ";
  answ1: "عالی";
  answ2: "خوب";
  answ3: "متوسط";
  answ4: "ضعیف";
  desc: "فرم شماره ۱";
  score1: 10;
  score2: 7;
  score3: 4;
  score4: 1;
  selected: string;
  score: number;
}

interface Props {
  onDismiss: () => void;
  open: boolean;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  barId: string;
}

export default function GiveScore(props: Props) {
  const { onDismiss, open, setStep, barId } = props;

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const [questions, setQuestions] = useState<ISurveyQuestion[]>([]);

  const { trigger: getSurveyTriger } = useSWRMutation(
    [`/Survey/GetNobatSetOrderSurvey`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setQuestions(data);
      },
    }
  );

  const {
    trigger: submitSurveyTrigger,
    // isMutating: isSubmitSurveyTriggerMutting,
  } = useSWRMutation(
    [`/Nobat/SetNobatSurvey`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        onDismiss();
      },
    }
  );

  useEffect(() => {
    getSurveyTriger({});
  }, []);

  const handleAnswer = (qId: string, selected: string, score: number) => {
    setQuestions((prev) => {
      return prev.map((q) => {
        if (q.id === qId) {
          return { ...q, selected, score };
        } else {
          return q;
        }
      });
    });
  };

  const handleSubmitSurvey = () => {
    let input: number = 0;
    const description = questions
      .map((item) => `${item.qstn}:${item.selected}`)
      .join();

    questions.map((item) => {
      input += item.score || 0;
    });

    submitSurveyTrigger({
      description,
      input,
      id: barId,
    });
  };

  return (
    <BottomSheetLayout height="100%" onDismiss={onDismiss} open={open}>
      <Box
        sx={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            mx: "auto",
            display: "flex",
            gap: "4px",
            alignItems: "center",
            border: "1px solid",
            padding: "10px",
            borderRadius: "10px",
            backgroundColor: theme.palette.bgColor.blueGrey50,
            borderColor: theme.palette.bgColor.blueGrey100,
          }}
        >
          <StarFillSVG color={theme.palette.secondary.main} />
          <Typography>امتیاز به صاحب کالا</Typography>
        </Box>
        <Box
          sx={{
            my: 1,
            flex: 1,
            overflowY: "auto",
            gap: "8px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {questions.map((item, index) => (
            <QuestionCard handleAnswer={handleAnswer} index={index} {...item} />
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
          }}
        >
          <CustomButton
            onClick={() => setStep(0)}
            justifyContent="center"
            title="انصراف"
            bgColor="#fff"
            fSize="16px"
            px="32px"
            borderColor={grey[800]}
            textColor="textColor.main"
            py="12px"
            borderRadius="6px"
          />
          <CustomButton
            onClick={handleSubmitSurvey}
            flex={1}
            justifyContent="center"
            title="تایید ثبت نظرسنجی"
            bgColor="secondary.main"
            fSize="16px"
            px="8px"
            py="8px"
            borderRadius="6px"
            icon1={<StarFillSVG />}
          />
        </Box>
      </Box>
    </BottomSheetLayout>
  );
}
